<template>
    <div class="full-container" v-io="{ exposeOnce: true }" @exposed="onExposed">
        <SearchInput :placeholder="searchPlaceHolder" v-model="searchValue" @input="search"></SearchInput>
        <csc-list
            :list="renderList"
            emptyText="没有找到合适的结果"
            :showLoading="showLoading"
            class="radio-list"
            :class="{'no-show-empty': !showEmpty}"
        >
            <div
                class="radio-item"
                v-for="(item, index) in renderList"
                :key="item.value + '-' + index"
                @click="onRadioClick(item)"
            >
                <div class="item-text">
                    {{ item.label }}
                </div>
                <div class="radio-icon" :class="selected === item.value ? 'radio-checked' : 'radio-unchecked' "></div>
            </div>
            <div class="no-more-data">
                没有更多内容了
            </div>
        </csc-list>
        <no-result-btn @on-no-result-click="onNoResult" sceneType="bank"></no-result-btn>
    </div>
</template>
<script>
import SearchInput from '../component-base/common/search-input';
import NoResultBtn from '../component-base/common/no-result-btn';
import CscDesign from '@ks-csc/mobile-design';
import IntersectionObserve from '../../utils/directives/intersection-observe';
import { searchBank, getBankBranch } from './service';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { RESULT_FALLBACK_VALUE } from '../../const';
const { CscList } = CscDesign;
export default {
    name: 'bank-list',
    directives: {
        io: IntersectionObserve,
    },
    components: {
        SearchInput,
        CscList,
        NoResultBtn,
    },
    props: {
        bankParams: {
            type: Object,
            default: () => {},
        },
        selectedValue: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dataList: [],
            renderList: [],
            selected: -1,
            searchValue: '',
            showLoading: false,
            showEmpty: false,
            hasMoreData: false,
            searchPlaceHolder: '',
            originBranchList: [],
        };
    },
    watch: {
        selectedValue: {
            handler(value) {
                this.selected = value[0] ? value[0].value || -1 : -1;
            },
        },
        dataList: {
            handler(value) {
                this.renderList = [...value];
            },
        },
        bankParams: {
            // immediate: true,
            async handler(value) {
                const { type, bankData, cityData } = value;
                this.searchPlaceHolder = type === 'branch' ? '输入支行名称' : '输入银行名称';
                this.searchValue = '';
                if (type === 'branch') {
                    this.showEmpty = true;
                    try {
                        this.showLoading = true;
                        this.dataList = [];
                        const list = await getBankBranch({
                            bankCode: bankData.value || '',
                            // bankName: bankData.text || '',
                            cityCode: cityData.cityCode || '',
                            // cityName: cityData.cityName || '',
                            provinceCode: cityData.code || '',
                            // provinceName: cityData.provinceName || '',
                        }) || [];
                        this.originBranchList = list.map(item => ({
                            label: item.name,
                            value: item.line_number || item.lineNumber || '',
                        }));
                        this.dataList = this.originBranchList;
                        this.showLoading = false;
                    } catch (e) {
                        this.showLoading = false;
                    }
                }
            },
        },
    },
    methods: {
        onNoResult() {
            this.$emit('selected', {
                label: RESULT_FALLBACK_VALUE,
                value: RESULT_FALLBACK_VALUE,
                phone: '',
            });
        },
        onRadioClick(item) {
            const { value } = item;
            this.selected = value || -1;
            this.$emit('selected', item);
        },
        async search(keyword) {
            this.showEmpty = true;
            const { type, bankData, cityData } = this.bankParams;
            if (type === 'branch') {
                if (!keyword) {
                    this.dataList = this.originBranchList;
                } else {
                    this.dataList = this.originBranchList.filter(item => item.label.includes(keyword));
                }
                this.sendSearchResLog(this.dataList);
            } else {
                // {bankCode: "BOC", bankName: "中国银行"}
                this.showLoading = true;
                try {
                    const list = await searchBank({
                        keyword,
                    }) || [];
                    this.sendSearchResLog(list);
                    this.dataList = list.map(item => ({
                        label: item.name,
                        value: item.code,
                        phone: item.phone || '',
                    }));
                    this.showLoading = false;
                } catch (e) {
                    this.showLoading = false;
                }
            }
        },
        sendSearchResLog(resList) {
            if (resList.length) {
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'SELECTOR_POPUP_SEARCH_RESULT', {
                    title: this.bankParams.bankPickerTitle,
                });
            }
        },
        onExposed() {
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'SELECTOR_POPUP_SEARCH', {
                title: this.bankParams.bankPickerTitle,
            });
        },
    },
};
</script>

<style lang="less" scoped>
.full-container {
    border-top: 0.5px var(--border-evaluate, #eaeaea) solid;
    height: 100%;
    display: flex;
    flex-direction: column;
    .no-show-empty {
        /deep/.no-data {
                display: none;
            }
    }
  .radio-list {
    flex: 1;
    overflow: auto;
      /deep/.no-data {
        margin-top: 226px;
        & > p {
          font-size: 18px;
          margin-top: 12px;
        }
      }
      /deep/.loading {
        margin-top: 230px;
      }
      .no-more-data {
        padding: 40px 0;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: var(--font-notice, #9c9c9c);
      }
      .radio-item{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 16px 19px;
          color: var(--font-common,#222);
          font-size: 16px;
          line-height: 22px;
          border-bottom: 1px solid var(--bg-solve-entity, #f8f8f8);
          .item-text {
            max-width: 360px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .radio-icon {
              width: 20px;
              height: 20px;
              background-size: 100% 100%;
          }
          .radio-checked {
              background-image: url('../../../assets/images/checked.svg');
          }
          .radio-unchecked {
              background-image: url('../../../assets/images/unchecked.svg');
          }
      }
  }
}
</style>
